import { loader } from 'graphql.macro';

import { appClient } from 'src/config/apollo';
import { MeditationProgressNode } from 'src/generated/webapp_gql';

const START_MEDITATION_MUTATION = loader('../documents/startMeditationMutation.graphql');
const FINISH_MEDITATION_MUTATION = loader('../documents/finishMeditationMutation.graphql');

export class MeditationService {
    public async startMeditation(meditationUuid: string): Promise<MeditationProgressNode[]> {
        return appClient
            .mutate({
                mutation: START_MEDITATION_MUTATION,
                variables: { meditationUuid },
            })
            .then(result => result.data?.meditationProgress)
            .catch(() => null);
    }

    public async finishMeditation(meditationUuid: string): Promise<MeditationProgressNode[]> {
        return appClient
            .mutate({
                mutation: FINISH_MEDITATION_MUTATION,
                variables: { meditationUuid },
            })
            .then(result => result.data.meditationProgress)
            .catch(() => null);
    }
}
